import gtm from '@/utils/gtm';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useRef } from 'react';

function processTitleHTML(title: string, isNoFollow: boolean): string {
    if (!title) return title;

    // 去掉所有 <a> 上的 rel 属性
    let result = title.replace(/(<a\b[^>]*?)\s+rel=(["']).*?\2([^>]*>)/gi, '$1$3');

    if (isNoFollow) {
        // 给 <a> 添加 rel="nofollow"
        result = result.replace(/<a\b([^>]*?)>/gi, (match, attrs) => {
            // 已经有 rel 的在上面已被移除，这里可以直接追加
            if (/\srel\s*=/.test(attrs)) return match;
            return `<a${attrs} rel="nofollow">`;
        });
    }

    return result;
}

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { position, color, bgColor, title, isNoFollow } = data;
    const { locale = 'us' } = useRouter();
    const compStyle = {
        '--editor-blog-richtext-color': color,
        '--editor-blog-richtext-bg-color': bgColor,
    };
    const refA = useRef<HTMLDivElement>(null);

    const initTitle = useMemo(
        () => processTitleHTML(title, isNoFollow),
        [title, isNoFollow],
    );
    useEffect(() => {
        const pathnameA = location.pathname;
        const initHandleA = () => {
            const elemA = refA.current;
            if (!elemA) {
                return;
            }
            elemA.addEventListener('click', (e: any) => {
                const targetA = e.target.closest('a');
                // 如果没有找到a标签，直接返回
                if (!targetA) {
                    return;
                }
                let targetB = e.target;
                if (targetB.tagName !== 'A') {
                    targetB = targetB.parentElement;
                }
                if (targetB.tagName !== 'A') {
                    targetB = targetB.parentElement;
                }

                const textA = targetB.textContent || '';
                const hrefA = targetB.getAttribute('href') || '';
                if (!hrefA || !textA) {
                    return;
                }

                if (hrefA.includes(`${locale}.ecoflow.com`)) {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: textA,
                        position: `blog_${pathnameA}`,
                        __btn_id1: `temp-${id}`,
                        __btn_id2: hrefA,
                        __btn_type: 'bloghref',
                    });
                } else if (hrefA.includes('www.ecoflow.com')) {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'select_product',
                        list_name: 'none',
                        product_name: textA,
                        button_name: textA,
                        __btn_id1: `temp-${id}`,
                        __btn_id2: hrefA,
                        __btn_type: 'bloghref',
                    });
                } else {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'blog_other_link',
                        button_name: textA,
                        __btn_id1: `temp-${id}`,
                        __btn_id2: hrefA,
                        __btn_type: 'bloghref',
                    });
                }
            });
        };
        initHandleA();
    }, []);

    return (
        <GloLayout id={id} className={`editor-blog-richtext position-${position}`} style={compStyle}>
            {!!initTitle && (
                <div
                    ref={refA}
                    className="richtext-title"
                    dangerouslySetInnerHTML={{
                        __html: initTitle,
                    }}
                ></div>
            )}
        </GloLayout>
    );
}
